<template>
  <div>
    <common-search-form-wrapper :reset="handleResetSearch">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="班级名称:" prop="name">
              <el-input
                v-model="searchInfo.name"
                placeholder="班级名称"
                maxlength="100"
                @change="handleSearchClass"
                clearable
                @clear="handleSearchClass"
                prefix-icon="el-icon-search"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 暂时注释，看教务那边是否需要 -->
          <!-- <el-col :span="8">
            <el-form-item label="班级简称:" prop="sub_name">
              <el-input
                v-model="searchInfo.sub_name"
                placeholder="班级简称"
                maxlength="100"
                @change="handleSearchClass"
                clearable
                @clear="handleSearchClass"
                prefix-icon="el-icon-search"
              >
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="班级学员:" prop="student_id">
              <el-select
                v-model="searchInfo.student_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchStudent"
                @focus="handleSearchStudent('')"
                @change="handleSearchClass"
              >
                <el-option
                  v-for="item in searchStudentList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课老师:" prop="teacher_id">
              <el-select
                v-model="searchInfo.teacher_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchTeacher"
                @focus="handleSearchTeacher('')"
                @change="handleSearchClass"
              >
                <el-option
                  v-for="item in searchTeacherList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:" prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchCourse"
                @focus="handleSearchCourse('')"
                @change="handleSearchClass"
              >
                <el-option
                  v-for="item in searchCourseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="授课老师:" prop="teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[1]"
                @change="handleSearchClass"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课教室:" prop="classroom_id">
              <el-select
                v-model="searchInfo.classroom_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchClassRoom"
                @focus="handleSearchClassRoom('')"
                @change="handleSearchClass"
              >
                <el-option
                  v-for="item in searchClassRoomList"
                  :key="item.classroom_id"
                  :label="item.name"
                  :value="item.classroom_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级人数:" prop="class_student_full">
              <el-radio-group
                v-model="searchInfo.class_student_full"
                @change="handleSearchClass"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">满班</el-radio-button>
                <el-radio-button label="2">未满班</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级状态:" prop="completion_status">
              <el-radio-group
                v-model="searchInfo.completion_status"
                @change="handleSearchClass"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">未结业</el-radio-button>
                <el-radio-button label="2">已结业</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分类:" prop="classification">
              <el-radio-group
                v-model="searchInfo.classification"
                @change="handleSearchClass"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">正课</el-radio-button>
                <el-radio-button :label="2">体验</el-radio-button>
                <el-radio-button :label="3">补课</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div class="searchBottom">
      <div class="head-btns">
        <div
          class="mwow-button-filled success"
          @click="showAddClassDialog"
          style="margin-right: 10px"
        >
          添加班级
        </div>
        <div
          class="mwow-button-filled disable"
          v-if="multipleSelection.length === 0"
        >
          批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
        </div>
        <el-popover
          v-else
          placement="bottom"
          width="70"
          trigger="click"
          :visible-arrow="false"
          popper-class="no-padding"
          :disabled="multipleSelection.length === 0"
        >
          <slot>
            <div class="muti-buttons">
              <div class="btn" @click="handleMultiDelete">班级结业</div>
              <div class="btn" @click="changeTeacherDialogVisible = true">
                授课老师
              </div>
            </div>
          </slot>
          <div slot="reference" class="mwow-button-filled primary">
            批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
          </div>
        </el-popover>
      </div>
      <div class="multipleStatistics">
        1vN班级共 {{ tatistics.count }}个，未结业
        {{ tatistics.not_completion_count }}个，已结业
        {{ tatistics.completion_count }}个
      </div>
    </div>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      @sort-change="clickSort"
      :default-sort="{ prop: 'create_time', order: 'descending' }"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        :selectable="
          (row) => {
            return row.completion_status === 1;
          }
        "
      >
      </el-table-column>
      <el-table-column label="班级名称" prop="name" width="190">
        <template slot-scope="scope">
          <span
            class="nameData green"
            @click="toDetail(String(scope.row.class_id))"
            >{{ scope.row.name }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="班级简称" prop="sub_name" width="100">
        <template slot-scope="scope">
          {{ scope.row.sub_name ? scope.row.sub_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="分类" prop="class_type" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.class_type === 1">正课</div>
          <div v-if="scope.row.class_type === 2">体验</div>
          <div v-if="scope.row.class_type === 3">补课</div>
        </template>
      </el-table-column>
      <el-table-column label="排课课程" prop="course_string"></el-table-column>
      <el-table-column label="授课教师">
        <template slot-scope="scope">
          <span
            class="dot"
            v-for="(item, index) in scope.row.teacher_list"
            :key="index"
            >{{ item.name }}</span
          >
          <span v-if="scope.row.teacher_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="上课教室">
        <template slot-scope="scope">
          <div>{{ scope.row.classroom ? scope.row.classroom.name : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="排课课时"
        prop="consume_number"
        width="80"
      ></el-table-column>
      <el-table-column label="班级人数(当前 / 总)" align="center" width="210">
        <template slot-scope="scope">
          <span
            >{{ scope.row.current_student_count }} /
            {{ scope.row.preset_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="班级排课(已点 / 总)" align="center" width="210">
        <template slot-scope="scope">
          <span
            >{{ scope.row.finish_lesson_count }} /
            {{ scope.row.arrange_lesson_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="班级状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.completion_status == 1" class="green"
            >未结业</span
          >
          <span v-if="scope.row.completion_status == 2" class="red"
            >已结业</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column label="结业时间" prop="completion_time">
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <el-drawer
      title="添加班级"
      :visible.sync="addClassDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
    >
      <add-dialog :visible.sync="addClassDrawerVisible"></add-dialog>
    </el-drawer>
    <!-- 批量改动教师 -->
    <change-teacher-dialog
      :visible.sync="changeTeacherDialogVisible"
      :origin-data="multipleSelection"
      @change="handleRefresh"
    ></change-teacher-dialog>
  </div>
</template>
<script>
import {
  getClassList,
  getClassCount,
  completionClass,
} from "@/api/classManagement";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { classroomSelectListApi } from "@/api/classRoom";
import {
  getSelectCourseList,
  searchStudent,
  staffList,
} from "@/api/globalSearch";
import addDialog from "./addDialogMulti.vue";
import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import changeTeacherDialog from "../changeTeacherDialog.vue";

export default {
  props: ["visible"],
  name: "classListMutiple",
  components: {
    addDialog,
    commonStaffPullDown,
    CommonSearchFormWrapper,
    changeTeacherDialog,
  },
  data() {
    return {
      searchInfo: {
        student_id: "",
        name: "",
        sub_name: "", // 班级简称
        course_id: "",
        teacher_id: "",
        teacher_list: [],
        class_student_full: -1,
        completion_status: 1,
        sort_type: "desc",
        classroom_id: "",
        classification: -1,
      },
      showFormSearch: false, // 显示第三行搜索
      showFormText: "展开",
      searchStudentList: [],
      searchCourseList: [],
      searchTeacherList: [],
      searchClassRoomList: [],
      tableData: [],
      multipleSelection: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      addClassDrawerVisible: false,
      tatistics: [],
      changeTeacherDialogVisible: false,
    };
  },

  created() {
    if (this.$route.query.t_s_id) {
      this.searchInfo.teacher_id = Number(this.$route.query.t_s_id);
    }
    if (this.$route.query.cl_pe === "2") {
      this.searchInfo.class_student_full = Number(2);
    }
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = this.$route.params;
      if (params.tab === "multiple") {
        if (params.teacher_id) {
          this.searchInfo.teacher_id = Number(params.teacher_id);
        }
      }
    } else {
      const cache = PageModule.pageInfo.classManage;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleRefresh();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleRefresh();
    }
  },
  watch: {
    addClassDrawerVisible: {
      handler(n, o) {
        if (!n) {
          // 弹窗关闭后刷新数据
          this.handleSearchClass();
          this.getTotalData();
        }
      },
      immediate: false,
      deep: false,
    },
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        student_id: "",
        name: "",
        sub_name: "",
        course_id: "",
        teacher_id: "",
        teacher_list: [],
        class_student_full: -1,
        completion_status: 1,
        sort_type: "desc",
        classroom_id: "",
        classification: -1,
      };
      this.handleSearchClass();
    },
    getTotalData() {
      getClassCount({
        course_type: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.tatistics = res.data;
        }
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 1000,
        key_word: v,
        status: [2],
      }).then((res) => {
        this.searchStudentList = res.data.list;
      });
    },
    handleSearchTeacher(v) {
      staffList({
        page: 1,
        page_size: 100,
        key_word: v,
        job_ids: [1],
      }).then((res) => {
        if (res.error_code === 0) {
          // res.data.list.unshift({
          //   name: "未分配授课老师",
          //   staff_id: 0,
          // })
          this.searchTeacherList = res.data.list;
        }
      });
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchCourseList = res.data.list;
        }
      });
    },
    handleSearchClassRoom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
        }
      });
    },
    getCount() {
      const option = {
        course_type: 1,
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (this.searchInfo.sub_name) {
        option.sub_name = this.searchInfo.sub_name;
      }
      if (this.searchInfo.course_id > 0) {
        option.course_id = Number(this.searchInfo.course_id);
      }
      if (typeof this.searchInfo.teacher_id === "number") {
        option.teacher_id = Number(this.searchInfo.teacher_id);
      }
      if (Number(this.searchInfo.class_student_full) >= 0) {
        option.class_student_full = this.searchInfo.class_student_full;
      }
      if (Number(this.searchInfo.completion_status) >= 0) {
        option.completion_status = this.searchInfo.completion_status;
      }
      if (this.searchInfo.classification !== -1) {
        option.class_type = Number(this.searchInfo.classification);
      }
      getClassCount(option).then((res) => {
        if (res.error_code === 0) {
          this.tatistics = res.data;
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        course_type: 1,
        sort_field: "create_time",
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (this.searchInfo.sub_name) {
        option.sub_name = this.searchInfo.sub_name;
      }
      if (this.searchInfo.course_id) {
        option.course_id = Number(this.searchInfo.course_id);
      }
      if (typeof this.searchInfo.teacher_id === "number") {
        option.teacher_id = Number(this.searchInfo.teacher_id);
      }
      if (this.searchInfo.class_student_full >= 0) {
        option.class_student_full = this.searchInfo.class_student_full;
      }
      if (this.searchInfo.completion_status >= 0) {
        option.completion_status = this.searchInfo.completion_status;
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.student_id) {
        option.student_id = Number(this.searchInfo.student_id);
      }
      if (this.searchInfo.teacher_id) {
        option.teacher_id = Number(this.searchInfo.teacher_id);
      }
      if (this.searchInfo.classroom_id) {
        option.classroom_id = Number(this.searchInfo.classroom_id);
      }
      if (this.searchInfo.classification !== -1) {
        option.class_type = Number(this.searchInfo.classification);
      }
      this.getCount();
      getClassList(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            const str = [];
            item.course_list.map((it) => {
              str.push(it.title);
            });
            item.course_string = str.join("、");
            item.create_time = dateFormat(
              "YYYY-mm-dd",
              new Date(item.create_time * 1000)
            );
            item.completion_time = item.completion_time
              ? dateFormat("YYYY-mm-dd", new Date(item.completion_time * 1000))
              : "-";
          });
          this.tableData = res.data.list;
          this.page = params.page;
          this.total = res.data.total;
          // 缓存搜索数据
          PageModule.SET_PAGE_INFO({
            name: "classManage",
            key: "page",
            value: this.page,
          });
          PageModule.SET_PAGE_INFO({
            name: "classManage",
            key: "page_size",
            value: this.pageSize,
          });
          PageModule.SET_PAGE_INFO({
            name: "classManage",
            key: "search_info",
            value: this.searchInfo,
          });
        }
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handleMultiDelete() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      const arr = [];
      let className = [];
      for (const item of this.multipleSelection.values()) {
        className.push(item.name);
        arr.push(item.class_id);
      }
      className = className.join("、");
      this.$confirm(
        "结业后，班级内所有学员、未点名课次将被清除，并且此操作无法恢复。确定要结业？",
        `结业 - ${className}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          completionClass({ class_ids: arr }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "结业成功!",
              });
              this.handleRefresh();
              this.getTotalData();
            } else {
              this.$message({
                type: "error",
                message: "结业失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    showAddClassDialog() {
      this.addClassDrawerVisible = true;
    },
    hideAddClassDialog() {
      this.addClassDrawerVisible = false;
    },

    handleSearchClass() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    toDetail(id) {
      this.$router.push({
        name: "classManageDetail",
        query: {
          id: id,
        },
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    clickSort(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearchClass();
    },
  },
};
</script>
<style lang="scss" scoped>
.head-btns {
  margin-bottom: 12px;
}
.searchBottom {
  display: flex;
  justify-content: space-between;
  .multipleStatistics {
    background: #fff7e9;
    color: #5c5d5e;
    font-size: 12px;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
  }
}
.table-th-break {
  line-height: 16px;
  span {
    padding: 0 24px;
  }
}
.table-td-break {
  span {
    line-height: 12px;
    padding: 0 24px;
    &:first-child {
      border-right: 1px solid #e1e5e9;
    }
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
.nameData {
  cursor: pointer;
}
.green {
  color: #07d1aa;
}
.red {
  color: #f56c6c;
}
.muti-buttons {
  .btn {
    padding-left: 10px;
    line-height: 32px;
    font-size: 12px;
    color: #5c5d5e;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
      color: #07d1aa;
    }
  }
  .dialog-wrap {
    display: block;
  }
}
</style>
